'use client';

import React, { useState, ReactNode, useMemo, useEffect } from 'react';
import { useLocale } from 'next-intl';
import { CartConfigContext } from './CartConfigContext';

export const CartConfigProvider = ({ children }: { children: ReactNode }) => {
    const [enableCartAU, setEnableCartAU] = useState<boolean>(false);
    const [enableCartNZ, setEnableCartNZ] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const locale = useLocale();

    // Mark as loaded after initial mount
    useEffect(() => {
        // Set a small timeout to ensure header data has a chance to load
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 100);

        return () => clearTimeout(timer);
    }, []);

    // Determine if cart is enabled based on current locale
    const isCartEnabled = useMemo(() => {
        if (locale === 'au') {
            return enableCartAU;
        } else if (locale === 'nz') {
            return enableCartNZ;
        }
        return false;
    }, [locale, enableCartAU, enableCartNZ]);

    return (
        <CartConfigContext.Provider
            value={{
                enableCartAU,
                setEnableCartAU,
                enableCartNZ,
                setEnableCartNZ,
                isCartEnabled,
                isLoading
            }}
        >
            {children}
        </CartConfigContext.Provider>
    );
};
